import React, { useEffect, useState } from 'react'
import '../App.css'
import QueryPersonalReportForm from './components/QueryPersonalReportForm'
import { Center, Image, Loader, Stack } from '@mantine/core'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { facade } from '../api/orderService'
import { TemplateMerchantInterface } from '../typings/orderTypes'
import RightFloating from '../components/RightFloating'
import QueryCompanyReportForm from './components/QueryCompanyReportForm'
import ReportElements from './components/ReportElements'
import InterceptorWrapper from '../components/InterceptorWrapper'
import HistoryOrdersButton from './components/HistoryOrdersButton'
import PaymentGuideCard from './components/PaymentGuideCard'
import { getThemeConfig } from '../utils/themeConfig'
import ReportSidebar from './components/ReportSidebar'
import ComplaintButton from '../components/ComplaintButton'
import { showNotification } from '../utils/notificationUtil'

export default function QueryReport() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const linkId = searchParams.get('linkId') || ''
  const [template, setTemplate] = useState<TemplateMerchantInterface>()
  const [loading, setLoading] = useState(true)

  const themeConfig = getThemeConfig(template?.themeType as number)

  useEffect(() => {
    const init = async () => {
      if (linkId === '') {
        navigate('/login')
        return
      }

      try {
        setLoading(true)
        const res = await facade(linkId)
        setTemplate(res)
      } catch (err) {
        showNotification.error('系统错误，请稍后再试')
      } finally {
        setLoading(false)
      }
    }

    init().then()
  }, [linkId, navigate])

  if (loading) {
    return (
      <Center h="100vh">
        <Loader color="#5087EB" size="lg" type="dots" />
      </Center>
    )
  }

  return (
    <InterceptorWrapper>
      <div className="min-h-screen flex flex-col" style={{ backgroundColor: themeConfig.backgroundColor }}>
        <div className="lg:hidden relative w-full">
          <Image
            src={themeConfig.backgroundImage}
            styles={{
              root: { margin: 0, padding: 0, display: 'block', width: '100%' },
            }}
          />
          <div
            className="absolute bottom-0 left-0 right-0 h-16"
            style={{
              background: `linear-gradient(to top, ${themeConfig.backgroundColor}, transparent)`,
            }}
          />
        </div>

        <div className="flex-1">
          <div className="w-full max-w-xl lg:max-w-container-sm xl:max-w-container-md 2xl:max-w-container-lg 3xl:max-w-container-xl mx-auto px-3 lg:px-6 pt-4 lg:pt-8 pb-8">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
              <div className="lg:col-span-7">
                <div className="bg-white rounded-xl py-5 mb-4 shadow-lg">
                  {template?.templateType === 1 && <QueryPersonalReportForm template={template} />}
                  {template?.templateType === 2 && <QueryCompanyReportForm template={template} />}
                </div>

                <div className="mb-4">
                  <ReportElements modules={template?.modules} themeConfig={themeConfig} />
                </div>

                <div className="mb-4">
                  <PaymentGuideCard themeConfig={themeConfig} />
                </div>
              </div>

              <div className="lg:col-span-5 hidden lg:block">
                <ReportSidebar
                  onSampleReportClick={() => navigate('/reportSamples/' + template?.templateId)}
                  themeConfig={themeConfig}
                />
              </div>
            </div>
          </div>
        </div>
        <RightFloating>
          <Stack align={'flex-end'} gap={0}>
            <HistoryOrdersButton
              onClick={() => {
                navigate('/orders')
              }}
              themeConfig={themeConfig}
              className="rounded-tl-lg"
            />
            <ComplaintButton themeConfig={themeConfig} className="rounded-bl-lg" />
          </Stack>
        </RightFloating>
      </div>
    </InterceptorWrapper>
  )
}
